import { isDefined } from "@clipboard-health/util-ts";
import { CircularProgress } from "@mui/material";
import { useIsMobileDevice } from "@src/appV2/redesign/AppLayout/useResponsive";
import { HOME_HEALTH_VISIT_VERIFICATION_MOBILE_PATH } from "@src/appV2/redesign/HomeHealth/VisitVerification/paths";
import { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

import { useCurrentUserId } from "../lib/useCurrentUserId";
import { useIsHomeHealthEnabled } from "../lib/useIsHomeHealthEnabled";
import { HOME_HEALTH_VISIT_VERIFICATION_PATH } from "./paths";

const VisitVerificationPage = lazy(
  async () =>
    await import("./VisitVerificationPage").then((module) => ({
      default: module.VisitVerificationPage,
    }))
);

export function HomeHealthProtectedVisitVerificationPage() {
  const currentUserId = useCurrentUserId();
  const isLoggedIn = isDefined(currentUserId);
  const isHomeHealthEnabled = useIsHomeHealthEnabled();

  const isMobile = useIsMobileDevice();

  if (!isLoggedIn) {
    localStorage.setItem("redirectURL", HOME_HEALTH_VISIT_VERIFICATION_PATH);
    return <Redirect to={`/enter?requestedUrl=${HOME_HEALTH_VISIT_VERIFICATION_PATH}`} />;
  }

  if (!isHomeHealthEnabled) {
    localStorage.removeItem("redirectURL");
    return <Redirect to="/" />;
  }

  if (isMobile) {
    return <Redirect to={HOME_HEALTH_VISIT_VERIFICATION_MOBILE_PATH} />;
  }

  return (
    <Suspense fallback={<CircularProgress />}>
      <VisitVerificationPage />
    </Suspense>
  );
}
